import app from 'flarum/forum/app';
import addLinkedAccountsToUserSecurityPage from './extenders/addLinkedAccountsToUserSecurityPage';
import extendLoginSignup from './extenders/extendLoginSignup';
import extendOAuthOnly from './extenders/extendOAuthOnly';
export { default as extend } from './extend';
export * from './components';
app.initializers.add('fof/oauth', () => {
  extendLoginSignup();
  extendOAuthOnly();
  addLinkedAccountsToUserSecurityPage();
  const params = new URLSearchParams(window.location.search);

  // Detect the _flarum_auth query parameter added by ResponseFactory after a
  // new-user OAuth callback. Strip it from the URL, fetch the token data from
  // the API to pre-populate the SignUpModal, then open the modal.
  const authToken = params.get('_flarum_auth');
  if (authToken) {
    params.delete('_flarum_auth');
    const clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', clean);

    // Defer until after app.mount() has run so the modal manager is mounted,
    // then resolve the token to username/email/provided before showing the modal.
    setTimeout(async () => {
      let modalAttrs = {
        token: authToken
      };
      try {
        const response = await app.request({
          method: 'POST',
          url: app.forum.attribute('apiUrl') + '/registration-token',
          body: {
            token: authToken
          }
        });
        modalAttrs = {
          token: authToken,
          username: response?.username ?? '',
          email: response?.email ?? '',
          provided: response?.provided ?? []
        };
      } catch {
        // If the fetch fails (e.g. token already used), fall back to opening
        // the modal with just the token — it will show empty fields.
      }
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'), modalAttrs);
    }, 0);
  }

  // Detect the _fof_oauth_unverified query parameter added when a provider's email isn't verified and an existing
  // account already uses it. Strip it from the URL and open the Log In modal, explaining how to link the provider.
  const unverifiedProvider = params.get('_fof_oauth_unverified');
  if (unverifiedProvider) {
    params.delete('_fof_oauth_unverified');
    const clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', clean);
    setTimeout(() => {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'), {
        fofOAuthUnverifiedEmailProvider: unverifiedProvider
      });
    }, 0);
  }

  // Detect the _flarum_linked query parameter added after a successful account
  // link (both manual from the security page and auto email-match on login).
  // Strip it from the URL and show the AccountLinkedModal.
  const linkedProvider = params.get('_flarum_linked');
  if (linkedProvider) {
    params.delete('_flarum_linked');
    const clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', clean);
    setTimeout(() => {
      app.modal.show(() => import(/* webpackChunkName: 'forum/components/AccountLinkedModal', webpackMode: 'lazy-once' */ './components/AccountLinkedModal'), {
        provider: linkedProvider
      });
    }, 0);
  }
});flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/components/AccountLinkedModal');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/index');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/extenders/addLinkedAccountsToUserSecurityPage');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/extenders/extendLoginSignup');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/extenders/extendOAuthOnly');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/extend');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/components/index');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/components/LinkedAccounts');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/components/LinkStatus');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/models/LinkedAccount');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/query/SsoGambit');
flarum.reg.addChunkModule('170', '104', 'fof-oauth', 'forum/components/ProviderInfo');